import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";

import { translateLang } from "../../../utils";
import { setLangs } from "../../langs/services";
import { useGetAllOrgLangsQuery } from "../services";

const useGetSaleLang = () => {
    const { orgId } = useParams();
    const { data } = useGetAllOrgLangsQuery({ org_id: orgId ?? "" }, { skip: !orgId });
    const currentLang = localStorage.getItem("lang") || "zh-TW";

    const names = useMemo(() => {
        const languages = data?.data.languages || [];
        const locales = languages.map((lang) => lang.language) || [];
        return locales.map((locale) => {
            return { lang: locale, name: translateLang({ locale, currentLang }) };
        });
    }, [data, currentLang]);

    return names;
};
export default useGetSaleLang;

export const useGetSaleLangOption = () => {
    const { orgId } = useParams();
    const dispatch = useDispatch();
    const { data: langData } = useGetAllOrgLangsQuery({ org_id: orgId ?? "" }, { skip: !orgId });

    const languages = useMemo(() => langData?.data.languages || [], [langData]);
    const locales = languages.map((lang) => lang.language) || [];
    const currentLang = localStorage.getItem("lang") || "zh-TW";
    const names = locales.map((locale) => {
        return {
            lang: locale,
            name: translateLang({ locale, currentLang }),
        };
    });
    const langTabRoutes =
        names?.map((row) => ({
            labelKey: row.name,
            href: row.lang,
        })) || [];
    const langs = useMemo(() => languages.map((lang) => lang.language), [languages]);

    useEffect(() => {
        if (!langs) return;
        dispatch(setLangs(langs));
    }, [langs, dispatch]);

    useEffect(() => {
        if (!langs) return;
        dispatch(setLangs(langs));
    }, [langs, dispatch]);

    return { names, langs, langTabRoutes };
};
